import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getScheduledNotifications, setScheduledNotificationItemData } from "../../features/admin4/admin4Slice"
import { useSelector } from "react-redux"
import moment from "moment"
import { BiEdit } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { showModal } from "../../features/modal/modalSlice"
const titleList = [
    ["Bildirim Tipi", "Kime", "Oluşturulma Tarihi", "Bildirim Tarihi", "Başlık", "Metin", "Menü", "İşlem"],
    ["Bildirim Tipi", "Kime","Oluşturulma Tarihi", "Bildirim Zamanı", "Başlık", "Metin", "Menü", "İşlem"],
    ["Bildirim Tipi", "Kime","Oluşturulma Tarihi", "Bildirim Zamanı", "Başlık", "Metin", , "Menü", "İşlem"]
]

const weekDayList = [
    {
        id: 1,
        text: "Pazartesi"
    },
    {
        id: 2,
        text: "Salı"
    },
    {
        id: 3,
        text: "Çarşamba"
    },
    {
        id: 4,
        text: "Perşembe"
    },
    {
        id: 5,
        text: "Cuma"
    },
    {
        id: 6,
        text: "Cumartesi"
    },
    {
        id: 7,
        text: "Pazar"
    },

]

const typeFilter = [
    {
        id: 2,
        text: "Tek Seferlik"
    },
    {
        id: 1,
        text: "Sürekli Haftalık"
    },
    {
        id: 0,
        text: "Sürekli Aylık"
    },


]
const Container = styled.div`
    padding: 30px;
    width: 100%;

    .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .h2{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
        }

        .type-filter-container{
            display: flex;
            gap: 10px;

            .type-btn{
                background-color: ${({theme}) => theme.secondaryBgColor};
                color: ${({theme}) => theme.mainTextColor};
                width: 120px;
                height: 40px;
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                border: 1px solid transparent;
            }

            .active-type-btn{
                color: var(--color-main);
                border-color: var(--color-main);
            }
        }
    }

    .table-container{


        .table{
            width: 100%;
            border-collapse: collapse;

            thead{
                width: 100%;
                background-color: var(--color-main);

                tr{

                    th{
                        color: #fff;
                        padding: 10px 12px;
                        border-right: 1px solid #fff;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        text-align: start;
                        width: 200px;

                        &:first-child{
                            border-left: 1px solid var(--color-main);
                        }

                        &:last-child{
                            text-align: center;
                            border-right: 1px solid var(--color-main);
                            width: 150px;
                        }

                        .title-text{
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            .sort-icon{
                                font-size: 1rem;
                                cursor: pointer;
                            }
                        }

                    }
                }
            }

            tbody{

                tr{
                    td{

                        border: 1px solid ${({theme}) => theme.mainTextColor};
                        text-align: start;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        padding: 10px 12px;

                        &:last-child{
                            text-align: center;
                        }



                        .action{
                            text-decoration: underline;
                            font-size: 12px;
                            font-weight: var(--font-weight-xl);
                            cursor: pointer;

                            &:first-child{
                                color: var(--color-yellow);
                                color: ${({theme}) => theme.secondaryTextColor};
                            }

                            &:last-child{
                                color: var(--color-main);
                                margin-left: 10px;
                            }

                        }

                    }

                    .td-relative{
                        position: relative;

                        .absolute{
                            position: absolute;
                            top: 36px !important;
                            background-color: ${({theme}) => theme.mainBgColor};
                            color: ${({theme}) => theme.mainTextColor};
                            padding: 10px;
                            border-radius: 5px;
                            width: 100px;
                            border: 1px solid ${({theme}) => theme.mainBorderColor};
                            background-color: ${({theme}) => theme.secondaryBgColor};
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                            z-index: 5;
                        }



                    }
                }

            }
        }



    }
`

const ScheduledNotificationList = () => {

    const {
        isLoadingGetScheduledNotifications,
        scheduledNotificationList
    } = useSelector(state => state.admin4)

    const [activeTypeFilter, setActiveTypeFilter] = useState({
        id: 2,
        text: "Tek Seferlik",
        index: 0
    })

    const [hoveredItem, setHoveredItem] = useState(null)

    const dispatch = useDispatch()

    const [currentPage, setCurrentPage] = useState(1)


    useEffect(() => {
        dispatch(getScheduledNotifications({
            page:currentPage,
            isRegularType:activeTypeFilter.id
        }))
    },[currentPage, activeTypeFilter])


  return (
    <Container>
        <div className="top-container">
            <h2 className="h2">Planlı Bildirim Listesi</h2>
            <div className="type-filter-container">
                {
                    typeFilter.map((item,i) => (
                        <button className={item.id === activeTypeFilter.id ? "active-type-btn type-btn" : "type-btn"} key={i} onClick={() => {setActiveTypeFilter({...item, index:i})}}>{item.text}</button>
                    ))
                }
            </div>
        </div>

        <div className="table-container">
            <table className="table">
                <thead>
                    <tr>
                        {
                           titleList[activeTypeFilter.index]?.map((item,i) => (
                                <th key={i}>{item}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        scheduledNotificationList.map((item,i) => (
                            <tr key={i}>
                                {
                                    activeTypeFilter.id === 2 &&
                                    <>
                                        <td>Tek Seferlik</td>
                                        <td className="td-relative" onMouseEnter={() => !item.isEveryone && setHoveredItem(item?.$id)} onMouseLeave={() => setHoveredItem(null)} style={{cursor: item.isEveryone ? "initial" : "pointer", textDecoration: item.isEveryone ? "initial" : "underline"}}>{item.isEveryone && "Herkese"}{!item.isEveryone && `${item.scheduledNotificationRecipients.$values.length} Üyeye`}
                                            {
                                                hoveredItem === item.$id &&
                                                <div className="absolute">{item.scheduledNotificationRecipients.$values.map(innerItem => (
                                                    <span>{innerItem.phoneNumber}</span>
                                                ))}</div>
                                            }
                                        </td>
                                        <td>{moment(item.createdAt).format("lll", "tr")}</td>
                                        <td>{moment(item.scheduledTime).format("lll", "tr")}</td>
                                        <td>{item.title}</td>
                                        <td>{item.text}</td>
                                        <td>{item.routeName}/{item.screenName}</td>
                                        <td>
                                            {/* <span className="action" onClick={() => {dispatch(showModal("updateScheduledNotificationItem")); dispatch(setScheduledNotificationItemData({data:item, type: "update"}))}}>Güncelle</span> */}
                                            <span className="action" onClick={() => {dispatch(showModal("deleteScheduledNotificationPermission")); dispatch(setScheduledNotificationItemData({data:item}))}}>Kaldır</span>
                                        </td>
                                    </>
                                }
                                {
                                    activeTypeFilter.id === 1 &&
                                    <>
                                        <td>Sürekli (Haftalık)</td>
                                        <td className="td-relative" onClick={() => (console.log("rfgddsfdsfd"))} onMouseEnter={() => !item.isEveryone && setHoveredItem(item?.$id)} onMouseLeave={() => setHoveredItem(null)} style={{cursor: item.isEveryone ? "initial" : "pointer", textDecoration: item.isEveryone ? "initial" : "underline"}}>{item.isEveryone && "Herkese"}{!item.isEveryone && `${item.scheduledNotificationRecipients.$values.length} Üyeye`}
                                            {
                                                hoveredItem === item.$id &&
                                                <div className="absolute">{item.scheduledNotificationRecipients.$values.map(innerItem => (
                                                    <span>{innerItem.phoneNumber}</span>
                                                ))}</div>
                                            }
                                        </td>
                                        <td>{moment(item.createdAt).format("lll", "tr")}</td>
                                        <td>{`Her ${weekDayList.find(wItem => wItem.id === item?.weeklyDayId)?.text} Saat ${moment(item.scheduledTime).format('HH:mm')}`}</td>
                                        <td>{item.title}</td>
                                        <td>{item.text}</td>
                                        <td>{item.routeName}/{item.screenName}</td>
                                        <td>
                                            {/* <span className="action" onClick={() => {dispatch(showModal("updateScheduledNotificationItem")); dispatch(setScheduledNotificationItemData({data:item, type: "update"}))}}>Güncelle</span> */}
                                            <span className="action" onClick={() => {dispatch(showModal("deleteScheduledNotificationPermission")); dispatch(setScheduledNotificationItemData({data:item}))}}>Kaldır</span>
                                        </td>
                                    </>
                                }
                                {
                                    activeTypeFilter.id === 0 &&
                                    <>
                                        <td>Sürekli (Aylık)</td>
                                        <td className="td-relative" onClick={() => (console.log("rfgddsfdsfd"))} onMouseEnter={() => !item.isEveryone && setHoveredItem(item?.$id)} onMouseLeave={() => setHoveredItem(null)} style={{cursor: item.isEveryone ? "initial" : "pointer", textDecoration: item.isEveryone ? "initial" : "underline"}}>{item.isEveryone && "Herkese"}{!item.isEveryone && `${item.scheduledNotificationRecipients.$values.length} Üyeye`}
                                            {
                                                hoveredItem === item.$id &&
                                                <div className="absolute">{item.scheduledNotificationRecipients.$values.map(innerItem => (
                                                    <span>{innerItem.phoneNumber}</span>
                                                ))}</div>
                                            }
                                        </td>
                                        <td>{moment(item.createdAt).format("lll", "tr")}</td>
                                        <td>{`Her Ayın ${new Date(item.scheduledTime).getDate()}. Günü`}</td>
                                        <td>{item.title}</td>
                                        <td>{item.text}</td>
                                        <td>{item.routeName}/{item.screenName}</td>
                                        <td>
                                            {/* <span className="action" onClick={() => {dispatch(showModal("updateScheduledNotificationItem")); dispatch(setScheduledNotificationItemData({data:item, type: "update"}))}}>Güncelle</span> */}
                                            <span className="action" onClick={() => {dispatch(showModal("deleteScheduledNotificationPermission")); dispatch(setScheduledNotificationItemData({data:item}))}}>Kaldır</span>
                                        </td>
                                    </>
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    </Container>
  )
}

export default ScheduledNotificationList